import { Helmet } from "react-helmet";
import styled from "styled-components";
import ManufacturingImage from "../../assets/Manufacturing.jpg";
import ManufacturingImageTwo from "../../assets/ManufacturingTwo.jpeg";
import { GiServerRack } from "react-icons/gi";
import { RiEditBoxLine } from "react-icons/ri";
import { SiMaterialdesignicons } from "react-icons/si";
import { IoWarningOutline } from "react-icons/io5";
import { AiOutlineGlobal } from "react-icons/ai";
import { GoShieldCheck } from "react-icons/go";
import { AiOutlineMergeCells } from "react-icons/ai";
import { TbStopwatch } from "react-icons/tb";
import ConfidenceImage from "../../assets/confidence.jpg";

const Manufacturing = () => {
  const handleTalkToTeam = () => {
    window.location.href = "/contact-us";
  };

  return (
    <>
      <Helmet>
        <title>Medichy | Manufacturing</title>
        <meta
          name="description"
          content="Medichy offers comprehensive medical device manufacturing services with expertise in minimally invasive devices, catheter technologies, and regulatory compliance."
        />
      </Helmet>
      <TheManufacturing>
        <div className="manufacture-hero-section">
          <img src={ManufacturingImage} alt="page banner" />
          <div className="overlay"></div>
          <div className="hero-content">
            <h3>
              Transforming medical device concepts into manufacturable realities
            </h3>
            <p>
              Our expert manufacturing team combines medical expertise with
              engineering precision to deliver innovative, compliant, and
              scalable medical device solutions.
            </p>
            <button className="btn-secondary" onClick={handleTalkToTeam}>
              TALK TO OUR MANUFACTURING TEAM
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="container">
          <div className="reliable-partner">
            <div className="section-header">
              <h3>
                Your Partner for Reliable, High-Quality Medical Device
                Manufacturing
              </h3>
              <p className="section-subtitle">
                Medichy provides end-to-end medical device contract
                manufacturing across the USA, Europe, and Costa Rica. Our global
                clean room facilities support the production of complex plastic,
                metal, and composite components, with full-service capabilities
                that include assembly, cleaning, finishing, packaging,
                labelling, and sterilization.
              </p>
              <p className="section-description">
                We specialize in helping teams scale from prototype to
                production, delivering the capacity, compliance, and technical
                expertise needed to keep projects moving. With deep experience
                in design transfer, supply chain management, and process
                optimization, Medichy integrates seamlessly into your operation
                to ensure reliable, repeatable manufacturing at every stage.
                <br />
                <br />
                Our manufacturing hubs in Massachusetts, Sligo, and Costa Rica
                give you flexible options for pilot builds, scale-up programs,
                and full-volume production.
              </p>
            </div>
          </div>

          <div className="why-manufacture">
            <div className="section-header">
              <h3>Why Manufacturing Programs Slow Down</h3>
              <p className="section-subtitle">
                Manufacturing teams often face bottlenecks caused by resource
                constraints, fragmented suppliers, and increasing compliance
                demands. Medichy provides external capacity and technical depth
                to keep production timelines on track.
              </p>
            </div>

            <div className="why-imagery">
              <div className="why-imagery-image">
                <img src={ManufacturingImageTwo} alt="manufacturing imagery" />
                <div className="image-overlay-card"></div>
              </div>
              <div className="why-content">
                <div className="why-list">
                  <div className="why-item">
                    <span className="icon-wrapper">
                      <GiServerRack />
                    </span>
                    <span className="why-text">
                      Limited internal manufacturing capacity
                    </span>
                  </div>
                  <div className="why-item">
                    <span className="icon-wrapper">
                      <RiEditBoxLine />
                    </span>
                    <span className="why-text">
                      Managing multiple suppliers and handoffs
                    </span>
                  </div>
                  <div className="why-item">
                    <span className="icon-wrapper">
                      <SiMaterialdesignicons />
                    </span>
                    <span className="why-text">
                      Design transfer gaps and delays
                    </span>
                  </div>
                  <div className="why-item">
                    <span className="icon-wrapper">
                      <IoWarningOutline />
                    </span>
                    <span className="why-text">
                      Rising regulatory and quality pressures
                    </span>
                  </div>
                </div>
                <button className="btn-secondary" onClick={handleTalkToTeam}>
                  GET IN TOUCH
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div className="manufacturing-capacity">
            <div className="section-header">
              <h3>Manufacturing Capacity and Compliance Built In</h3>
              <p className="section-subtitle">
                We act as a trusted extension of your team, providing scalable
                production and technical oversight across global facilities.
              </p>
            </div>

            <div className="capacity-cards">
              <div className="capacity-card">
                <div className="card-icon">
                  <TbStopwatch />
                </div>
                <h5 className="card-title">Speed with Structure</h5>
                <p>
                  From concept to prototype in 90 to 180 days, with clarity at
                  every step.
                </p>
              </div>
              <div className="capacity-card">
                <div className="card-icon">
                  <AiOutlineMergeCells />
                </div>
                <h5 className="card-title">Integrated Model</h5>
                <p>
                  Design, engineering, and regulatory aligned in one accountable
                  partner.
                </p>
              </div>
              <div className="capacity-card">
                <div className="card-icon">
                  <GoShieldCheck />
                </div>
                <h5 className="card-title">Regulatory Built-In</h5>
                <p>Compliance from day one, no costly rework later.</p>
              </div>
              <div className="capacity-card">
                <div className="card-icon">
                  <AiOutlineGlobal />
                </div>
                <h5 className="card-title">Global Execution</h5>
                <p>Future-proofed for scale with Global capacity.</p>
              </div>
            </div>
          </div>

          <div className="start-with-confidence">
            <div className="confidence-container">
              <div className="confidence-image">
                <img src={ConfidenceImage} alt="confidence" />
                <div className="image-overlay-card"></div>
              </div>
              <div className="confidence-content">
                <h4>Start your project with confidence</h4>
                <p>
                  Whether you are a startup or an OEM, Medichy is ready to help
                  you accelerate development with clarity and compliance built
                  in from day one.
                </p>
                <button className="btn-secondary" onClick={handleTalkToTeam}>
                  GET IN TOUCH
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </TheManufacturing>
    </>
  );
};

const TheManufacturing = styled.div`
  width: 100%;
  min-height: 100vh;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .manufacture-hero-section {
    position: relative;
    height: 70vh;
    width: 100%;
    overflow: hidden;
    margin-bottom: 4rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.85) 0%,
        rgba(0, 50, 150, 0.9) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 900px;
      padding: 0 1rem;

      h3 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 1.5rem;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        line-height: 1;
      }

      p {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        margin-bottom: 2rem;
        line-height: 1.6;
        max-width: 700px;
        margin-left: auto;
        margin-right: auto;
      }

      .btn-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: transparent;
        color: white;
        border: 2px solid white;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: white;
          color: #3182ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 1rem;
    }

    .section-subtitle {
      font-size: 1.25rem;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
      margin: 0 auto 1.5rem;
    }

    .section-description {
      font-size: 1.1rem;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
      margin: 0 auto;
    }
  }

  .reliable-partner {
    padding: 4rem 0;

    .section-header {
      margin-bottom: 0;
    }
  }

  .why-manufacture {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .why-imagery {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;
      margin-top: 3rem;

      .why-imagery-image {
        position: relative;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        height: 400px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .image-overlay-card {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to right,
            rgba(0, 100, 200, 0.1),
            transparent
          );
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      .why-content {
        .why-list {
          margin-bottom: 2.5rem;

          .why-item {
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-bottom: 1.5rem;
            padding: 1rem;
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-4px);
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
            }

            .icon-wrapper {
              width: 50px;
              height: 50px;
              background: linear-gradient(135deg, #3182ce, #2c5282);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              color: white;
              font-size: 1.5rem;
            }

            .why-text {
              font-size: 1.1rem;
              font-weight: 500;
              color: #1a1a1a;
              line-height: 1.4;
            }
          }
        }

        .btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
          color: white;
          border: none;
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

            svg {
              transform: translateX(5px);
            }
          }

          svg {
            transition: transform 0.3s ease;
          }
        }
      }
    }
  }

  .manufacturing-capacity {
    padding: 4rem 0;

    .capacity-cards {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 2rem;
      margin-top: 3rem;

      .capacity-card {
        background: white;
        border-radius: 16px;
        padding: 2rem;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        text-align: center;
        border: 1px solid #e2e8f0;

        &:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .card-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          color: white;
          font-size: 2rem;
        }

        .card-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
          color: #666;
          line-height: 1.6;
          margin: 0;
        }
      }
    }
  }

  .start-with-confidence {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .confidence-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;

      .confidence-image {
        position: relative;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        height: 400px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .image-overlay-card {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to right,
            rgba(0, 100, 200, 0.1),
            transparent
          );
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      .confidence-content {
        h4 {
          font-size: 2rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 1.5rem;
          position: relative;
          display: inline-block;

          &:after {
            content: "";
            position: absolute;
            bottom: -8px;
            left: 0;
            width: 60px;
            height: 4px;
            background: linear-gradient(135deg, #3182ce, #2c5282);
            border-radius: 2px;
          }
        }

        p {
          font-size: 1.1rem;
          color: #666;
          line-height: 1.6;
          margin-bottom: 2.5rem;
        }

        .btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
          color: white;
          border: none;
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

            svg {
              transform: translateX(5px);
            }
          }

          svg {
            transition: transform 0.3s ease;
          }
        }
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    .manufacture-hero-section {
      height: 65vh;

      .hero-content {
        h3 {
          font-size: 3.25rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }

    .container {
      padding: 0 1.5rem;
    }

    .section-header {
      h3 {
        font-size: 2.25rem;
      }
    }

    .why-manufacture {
      .why-imagery {
        gap: 3rem;

        .why-imagery-image {
          height: 350px;
        }
      }
    }

    .start-with-confidence {
      .confidence-container {
        gap: 3rem;

        .confidence-image {
          height: 350px;
        }
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .manufacture-hero-section {
      height: 60vh;

      .hero-content {
        h3 {
          font-size: 3rem;
        }
      }
    }

    .manufacturing-capacity {
      .capacity-cards {
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;
      }
    }

    .why-manufacture {
      .why-imagery {
        .why-imagery-image {
          height: 320px;
        }
      }
    }

    .start-with-confidence {
      .confidence-container {
        .confidence-image {
          height: 320px;
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    .manufacture-hero-section {
      height: 55vh;
      margin-bottom: 3rem;

      .hero-content {
        h3 {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.875rem 2rem;
          font-size: 1rem;
        }
      }
    }

    .section-header {
      margin-bottom: 3rem;

      h3 {
        font-size: 2rem;
      }

      .section-subtitle {
        font-size: 1.1rem;
      }

      .section-description {
        font-size: 1rem;
      }
    }

    .reliable-partner {
      padding: 3rem 0;
    }

    .why-manufacture {
      padding: 3rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .why-imagery {
        grid-template-columns: 1fr;
        gap: 3rem;

        .why-imagery-image {
          height: 300px;
          order: 2;
        }

        .why-content {
          .why-list {
            .why-item {
              padding: 0.875rem;
              margin-bottom: 1rem;

              .icon-wrapper {
                width: 45px;
                height: 45px;
                font-size: 1.25rem;
              }

              .why-text {
                font-size: 1rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.875rem 2rem;
            font-size: 1rem;
          }
        }
      }
    }

    .manufacturing-capacity {
      padding: 3rem 0;

      .capacity-cards {
        grid-template-columns: 1fr;
        max-width: 400px;
        margin: 3rem auto 0;

        .capacity-card {
          padding: 1.5rem;

          .card-icon {
            width: 60px;
            height: 60px;
            font-size: 1.75rem;
          }
        }
      }
    }

    .start-with-confidence {
      padding: 3rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .confidence-container {
        grid-template-columns: 1fr;
        gap: 3rem;

        .confidence-image {
          height: 300px;
          order: 2;
        }

        .confidence-content {
          h4 {
            font-size: 1.5rem;
          }

          p {
            font-size: 1rem;
          }

          .btn-secondary {
            padding: 0.875rem 2rem;
            font-size: 1rem;
          }
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .manufacture-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 2rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.75rem 1.5rem;
          font-size: 0.9rem;
        }
      }
    }

    .container {
      padding: 0 1rem;
    }

    .section-header {
      margin-bottom: 2.5rem;

      h3 {
        font-size: 1.75rem;
      }

      .section-subtitle {
        font-size: 1rem;
      }

      .section-description {
        font-size: 0.95rem;
      }
    }

    .reliable-partner {
      padding: 2.5rem 0;
    }

    .why-manufacture {
      padding: 2.5rem 0;
      margin: 2.5rem 0;

      .why-imagery {
        .why-imagery-image {
          height: 250px;
        }

        .why-content {
          .why-list {
            .why-item {
              .icon-wrapper {
                width: 40px;
                height: 40px;
                font-size: 1.1rem;
              }

              .why-text {
                font-size: 0.95rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.75rem 1.5rem;
            font-size: 0.95rem;
          }
        }
      }
    }

    .manufacturing-capacity {
      padding: 2.5rem 0;

      .capacity-cards {
        .capacity-card {
          padding: 1.25rem;

          .card-icon {
            width: 55px;
            height: 55px;
            font-size: 1.5rem;
          }

          .card-title {
            font-size: 1.1rem;
          }

          p {
            font-size: 0.95rem;
          }
        }
      }
    }

    .start-with-confidence {
      padding: 2.5rem 0;
      margin: 2.5rem 0;

      .confidence-container {
        .confidence-image {
          height: 250px;
        }

        .confidence-content {
          h4 {
            font-size: 1.25rem;
          }

          p {
            font-size: 0.95rem;
          }

          .btn-secondary {
            padding: 0.75rem 1.5rem;
            font-size: 0.95rem;
          }
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    .manufacture-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 1.75rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-secondary {
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;
        }
      }
    }

    .section-header {
      h3 {
        font-size: 1.5rem;
      }

      .section-subtitle {
        font-size: 0.9rem;
      }

      .section-description {
        font-size: 0.9rem;
      }
    }

    .why-manufacture {
      .why-imagery {
        .why-imagery-image {
          height: 200px;
        }

        .why-content {
          .why-list {
            .why-item {
              .icon-wrapper {
                width: 35px;
                height: 35px;
                font-size: 1rem;
              }

              .why-text {
                font-size: 0.9rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.625rem 1.25rem;
            font-size: 0.85rem;
          }
        }
      }
    }

    .manufacturing-capacity {
      .capacity-cards {
        .capacity-card {
          .card-icon {
            width: 50px;
            height: 50px;
            font-size: 1.25rem;
          }

          .card-title {
            font-size: 1rem;
          }

          p {
            font-size: 0.9rem;
          }
        }
      }
    }

    .start-with-confidence {
      .confidence-container {
        .confidence-image {
          height: 200px;
        }

        .confidence-content {
          h4 {
            font-size: 1.1rem;
          }

          p {
            font-size: 0.9rem;
          }

          .btn-secondary {
            padding: 0.625rem 1.25rem;
            font-size: 0.85rem;
          }
        }
      }
    }
  }

  @media screen and (max-width: 350px) {
    .manufacture-hero-section {
      height: 100vh;

      .hero-content {
        h3 {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-secondary {
          padding: 0.5rem 1rem;
          font-size: 0.8rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }

    .container {
      padding: 0 0.5rem;
    }

    .section-header {
      h3 {
        font-size: 1.25rem;
      }

      .section-subtitle {
        font-size: 0.85rem;
      }

      .section-description {
        font-size: 0.85rem;
      }
    }

    .why-manufacture {
      .why-imagery {
        .why-imagery-image {
          height: 180px;
        }

        .why-content {
          .why-list {
            .why-item {
              .icon-wrapper {
                width: 30px;
                height: 30px;
                font-size: 0.9rem;
              }

              .why-text {
                font-size: 0.85rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.5rem 1rem;
            font-size: 0.8rem;

            svg {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }

    .manufacturing-capacity {
      .capacity-cards {
        .capacity-card {
          padding: 1rem;

          .card-icon {
            width: 45px;
            height: 45px;
            font-size: 1.1rem;
          }

          .card-title {
            font-size: 0.95rem;
          }

          p {
            font-size: 0.85rem;
          }
        }
      }
    }

    .start-with-confidence {
      .confidence-container {
        .confidence-image {
          height: 180px;
        }

        .confidence-content {
          h4 {
            font-size: 1rem;
          }

          p {
            font-size: 0.85rem;
          }

          .btn-secondary {
            padding: 0.5rem 1rem;
            font-size: 0.8rem;

            svg {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }
  }
`;

export default Manufacturing;
